export default [{
  name: 'stone',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PessoaDadosContato: {},
        PessoaBanco: {},
        PessoaEndereco: {}
      },
      Parcela: []
    },
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
    dadosIniciais (state, obj) {
      state.dadosIniciais = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    },
    dadosIniciais (state) {
      return state.dadosIniciais
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PessoaBanco: {},
          PessoaDadosContato: {},
          PessoaEndereco: {}
        },
        Parcela: []
      }
      commit('model', data)
    }
  },
}]
